import React, { Component } from 'react';
import PropTypes from "prop-types";
class SortableContainer extends Component {
    render() {
        return <span>{this.props.children}</span>;
    }
}

SortableContainer.propTypes = {
    children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
};

export default SortableContainer;